import { useParams } from 'react-router-dom';
import CustomerIcon from 'assets/customer.svg?react';

import { SidebarLayout } from '../../SidebarLayout';

const SHOW_CUSTOMERS_SECTION = import.meta.env.VITE_ALPHA_MODE === 'true';;

export const CustomersSection = () => {
  const { projectId } = useParams();
  
  return (
    SHOW_CUSTOMERS_SECTION && (
      <SidebarLayout.SidebarMainLayout.ListNavLink
        to={`/projects/${projectId}/customers`}
        label="Customers"
        iconSvg={<CustomerIcon width={24} height={24} />}
      />
    )
  );
};
